import React from 'react';
import { Alert, Tag, Space } from 'antd';

const EnhancedModeLegend = () => (
  <Alert
    className="enhanced-mode-legend"
    type="info"
    showIcon
    style={{ marginBottom: 16 }}
    message="Enhanced Rack Diagram"
    description={
      <div>
        <div style={{ marginBottom: 8 }}>
          Device faceplates show port layouts by equipment type. Click green
          ports to view details and cable links. Link each rack device to{' '}
          <strong>Device Registry</strong> and add <strong>Switch Port Registry</strong>{' '}
          rows to populate ports.
        </div>
        <Space wrap size={8}>
          <Tag color="default">Gray = empty slot</Tag>
          <Tag color="success">Green = registered port</Tag>
          <Tag color="processing">Blue = has cable link</Tag>
          <Tag color="purple">Purple = selected</Tag>
        </Space>
      </div>
    }
  />
);

export default EnhancedModeLegend;
